import { render, staticRenderFns } from "./dismissed-pipes.vue?vue&type=template&id=3b583600"
import script from "./dismissed-pipes.vue?vue&type=script&lang=js"
export * from "./dismissed-pipes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports